import styled from "styled-components";
import InputField from "components/UI/InputField";
import DatePickerField from "components/UI/DatePickerField";
import Button from "@mui/material/Button";
import { defaultValueGet } from "common/parameters_common";
import PanelAreas from "./PanelAreas";
import { useEffect, useState } from "react";
import { AreaSource } from "type/panel/Panel.type";

type PanelFormProps = {
  control: any;
  handleSubmit: Function;
  onSubmit: Function;
  reset: Function;
  defaultValues?: any;
  setValue?: any;
};

const PanelForm = ({
  control,
  onSubmit,
  handleSubmit,
  reset,
  defaultValues,
  setValue,
}: PanelFormProps) => {
  const [showGeneralFields, setShowGeneralFields] = useState<boolean>(false);
  useEffect(() => {
    if (defaultValueGet(defaultValues, "slug", "") === "") {
      setShowGeneralFields(true);
    }
  }, []);

  const datumDefault = defaultValueGet(defaultValues, "datum", new Date());
  const titleDefault = defaultValueGet(defaultValues, "title", "");
  const slugDefault = defaultValueGet(defaultValues, "slug", "");
  const areasDefault = defaultValueGet(defaultValues, "areas", []);

  const resetHandle = () => {
    reset();
    // TODO: reset area part to the state from last saving
  };

  const showGeneralFieldsToggle = () => {
    setShowGeneralFields(!showGeneralFields);
  };

  const areasUpdateHandle = (areas: AreaSource[]) => {
    setValue("areas", areas);
  };

  return (
    <DivForm>
      <div>
        general fields
        <Button onClick={showGeneralFieldsToggle}>
          {showGeneralFields ? "hide" : "show"}
        </Button>
      </div>
      <form>
        {showGeneralFields && (
          <>
            <DivField>
              <DatePickerField
                control={control}
                name="datum"
                label="Datum"
                defaultValue={datumDefault}
              />
            </DivField>
            <DivField>
              <InputField
                name="title"
                control={control}
                label="Title"
                defaultValue={titleDefault}
              />
            </DivField>
            <DivField>
              <InputField
                name="slug"
                control={control}
                label="Slug"
                defaultValue={slugDefault}
              />
            </DivField>
          </>
        )}
        <DivField>
          <PanelAreas
            defaultAreas={areasDefault}
            onAreasUpdate={areasUpdateHandle}
          />
        </DivField>

        <DivNav>
          <Button onClick={handleSubmit(onSubmit)} type="submit">
            Submit
          </Button>
          <Button onClick={resetHandle} variant={"outlined"}>
            Reset
          </Button>
        </DivNav>
      </form>
    </DivForm>
  );
};

const DivForm = styled.div`
  margin-top: 0.75rem;
`;

const DivField = styled.div`
  margin-top: 1rem;
`;

const DivNav = styled.div`
  margin-top: 2rem;
`;

export default PanelForm;
